import React, { useState, useEffect } from 'react';
import { get } from 'aws-amplify/api';
import ContactModal from './ContactModal';
import './BillingPage.css';

// お申し込み・変更・解約はすべてお問い合わせで受け付ける（アプリ内でのカード決済は行わない）
const CONTACT_TOPICS = [
  { icon: '🚀', title: '有料プランのお申し込み', desc: 'ユーザー数・タスク数の上限を広げたい場合' },
  { icon: '👥', title: 'ユーザー数の変更', desc: '利用人数の追加・削減をしたい場合' },
  { icon: '🧾', title: '請求書・お支払いについて', desc: '請求書・領収書の発行、お支払い方法のご相談' },
  { icon: '✋', title: '解約', desc: '有料プランの解約をご希望の場合' },
];

function BillingPage({ onBack, onFaq, user }) {
  const [billing, setBilling] = useState(null);
  const [loading, setLoading] = useState(true);
  const [contactOpen, setContactOpen] = useState(false);

  useEffect(() => {
    fetchBillingStatus();
  }, []);

  const fetchBillingStatus = async () => {
    try {
      const op = get({ apiName: 'worktimerApi', path: '/billing/status' });
      const res = await op.response;
      const data = await res.body.json();
      setBilling(data);
    } catch (e) {
      console.error('課金情報取得エラー:', e);
    } finally {
      setLoading(false);
    }
  };

  const isFree = !billing || billing.subscription_status === 'free';
  const isPastDue = billing?.subscription_status === 'past_due';

  const formatPeriodEnd = (dateStr) => {
    if (!dateStr) return null;
    const d = new Date(dateStr);
    return `${d.getFullYear()}年${d.getMonth() + 1}月${d.getDate()}日`;
  };

  if (loading) return (
    <div className="billing-loading">
      <div className="billing-spinner"></div>
    </div>
  );

  return (
    <div className="billing-page">
      <div className="billing-header">
        <button className="billing-back-btn" onClick={onBack}>← 戻る</button>
        <h2>プラン・課金</h2>
      </div>

      {/* 現在のプラン */}
      <div className="billing-section">
        <h3>現在のプラン</h3>
        <div className={`billing-plan-card ${isFree ? 'plan-free' : isPastDue ? 'plan-pastdue' : 'plan-active'}`}>
          <div className="plan-badge">
            {isFree ? '無料プラン' : isPastDue ? 'お支払い確認中' : '有料プラン'}
          </div>
          <div className="plan-stats">
            <div className="plan-stat">
              <span className="stat-label">ユーザー</span>
              <span className="stat-value">
                {billing?.current_users || 0} / {billing?.max_users || 3} 人
              </span>
            </div>
            <div className="plan-stat">
              <span className="stat-label">タスク</span>
              <span className="stat-value">
                {isFree
                  ? `${billing?.current_tasks || 0} / 3 個`
                  : `${billing?.current_tasks || 0} 個`}
              </span>
              {!isFree && <span className="stat-sub-line">無制限</span>}
            </div>
            {!isFree && billing?.current_period_end && (
              <div className="plan-stat">
                <span className="stat-label">契約更新日</span>
                <span className="stat-value">{formatPeriodEnd(billing.current_period_end)}</span>
              </div>
            )}
          </div>
          {billing?.pending_max_users != null && (
            <div className="plan-pending-notice">
              翌月1日より {billing.pending_max_users} 人プランに変更予定
            </div>
          )}
        </div>
      </div>

      {/* お申し込み・変更・解約 */}
      <div className="billing-section">
        <h3>{isFree ? '有料プランのお申し込み' : 'プランの変更・解約'}</h3>
        <div className="billing-upgrade-card">
          <div className="upgrade-contact">
            <p>
              プランのお申し込み・変更・解約、料金のご案内は、すべてお問い合わせにて承っております。<br />
              担当者よりご登録のメールアドレス宛にご連絡いたします。
            </p>
            <button className="upgrade-contact-btn" onClick={() => setContactOpen(true)}>
              お問い合わせはこちら
            </button>
          </div>
          <ul className="contact-topic-list">
            {CONTACT_TOPICS.map((t) => (
              <li key={t.title} className="contact-topic-item">
                <span className="contact-topic-icon">{t.icon}</span>
                <div>
                  <div className="contact-topic-title">{t.title}</div>
                  <div className="contact-topic-desc">{t.desc}</div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* よくある質問 */}
      <div className="billing-section">
        <div className="billing-faq-row">
          <span className="billing-faq-label">ご不明な点はFAQをご確認ください</span>
          <button className="billing-faq-btn" onClick={onFaq}>
            よくある質問 →
          </button>
        </div>
      </div>

      <ContactModal
        open={contactOpen}
        onClose={() => setContactOpen(false)}
        defaultCategory="プランのお申し込み・変更・解約"
        defaultName={user?.display_name || ''}
        defaultEmail={user?.email || ''}
      />
    </div>
  );
}

export default BillingPage;
